import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "root",
  class: "absolute bottom-0 left-0 right-0 flex justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Indicator = _resolveComponent("Indicator")!

  return (_ctx.quantityOffScrollElements > 1)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scrollItemsArray, (indicator, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createVNode(_component_Indicator, {
              "active-index": _ctx.activeIndex,
              index: index,
              onOnScrollTo: _ctx.scrollToClickedItem
            }, null, 8, ["active-index", "index", "onOnScrollTo"])
          ]))
        }), 128))
      ], 512))
    : _createCommentVNode("", true)
}